import { Store } from 'Application/Store/Store'
import { setviewportMode } from 'Domain/Scene/Handler/ViewportHandler'
import { initializeScene, getScene } from './SceneInitializer'
import { renderAllViewports, adjustStrippingScaleForViewport, adjustMarkupScaleForViewport } from './RenderLoop'
import { syncOrbitControlState } from './ControlSyncManager'
export {
  setVersions,
  setKeyframeToEnd,
  setKeyframeToBegin,
  toogleAnimationVisible,
  setKeyframeTo,
  setSceneLoaded
} from './ReduxActionCreators'

export { keyframe } from './VisibilityManager'

export const SceneManager = async (canvas, model, projectMetas) => {
  const { renderer } = await initializeScene(canvas, model, projectMetas)

  const update = () => {
    const w = window.innerWidth
    const h = window.innerHeight
    setviewportMode(Store.getState().ViewportReducer.viewportMode)
    adjustStrippingScaleForViewport()
    adjustMarkupScaleForViewport()
    syncOrbitControlState()
    renderer.setSize(w, h)
    renderAllViewports(getScene(), renderer, w, h)
  }

  return { update }
}
